import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { ExpenseService } from "../../../_service/ExpenseService";
import { useAppSelector } from "../../../_app";
import { Notify, Utils } from "../../../utils";
import { LoaderContainer } from "../../../CommonStyles";
import { Loader } from "../../../components";
import { HiOutlineExternalLink } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

// Sample Data
const expenseItems = [
  { id: 1, title: "Business Entertainment" },
  { id: 2, title: "CPF And Donation Adjustment" },
  { id: 3, title: "CPF Refund" },
  { id: 4, title: "Expense" },
  { id: 5, title: "Extra Day" },
  { id: 6, title: "Foreign Travel Expenses" },
  { id: 7, title: "Local Small Purchase" },
  { id: 8, title: "Medical Claim" },
  { id: 9, title: "Mobile Phone" },
  { id: 10, title: "Office Expense" },
  { id: 11, title: "Pay-in Lieu Of Notice" },
  { id: 12, title: "Previous Month Wag" },
  { id: 13, title: "Transport Claim" },
];

// Styled Components
const Wrapper = styled.div`
  min-height: 100vh;
  background-color: #f9f9f9;
`;

const MainHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5ea;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
`;

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: bold;
  color: #283a44;
`;

const Button = styled.button`
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: none;
  font-weight: 500;
  cursor: pointer;
`;

const Card = styled.div`
  max-width: 900px;
  margin: auto;
  color: #283a44;
`;

const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  border: 1px solid #e5e5ea;
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.4rem;
  padding-right: 2rem;
`;

const Label = styled.div`
  font-size: 0.875rem;
  color: #333;
`;

const CheckboxWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #28a745;
    border-color: #28a745;
  }

  &:checked + span::after {
    display: block;
  }

  :disabled + span {
    /* background-color: #eee;
    border-color: #eee; */
    cursor: default;
  }
`;

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 4px;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    display: none;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #000;
  cursor: pointer;
  border: 1px solid #e5e5ea;
  padding: 12px 14px;
  border-radius: 4px;
  border-left: 4px solid #001BB7;

  &:hover {
    background-color: #f0f0f0;
    font-weight: 500;
  }
`;

const MessageLink = styled.p`
  color: #0046FF;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  /* border-bottom: 1px dashed #001BB7; */
  
`;

const ExpenseAccounts = () => {
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expenseItems, setExpenseItems] = useState<any[]>([]);

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);
  const navigate = useNavigate();

  const getExpenseItems = async () => {
    setIsLoading(true);
    try {
      const res = await ExpenseService._getExpenseItems(companyId);
      if (res.status === 200) {
        setExpenseItems(res?.data?.data);
        setSelectedItems(
          res?.data?.data
            ?.filter((item: any) => item.is_checked)
            ?.map((item: any) => item.custom_input_id)
        );
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getExpenseItems();
  }, []);

  const handleCheckboxChange = (id: number) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSave = useCallback(async () => {
    let payload = {
      company: companyId,
      custom_input_ids: selectedItems,
    };

    console.log("Save Expense items:", payload);

    try {
      setIsLoading(true);
      const { status } = await ExpenseService._saveExpenseItems(payload);
      if (status >= 200 && status < 300) {
        Notify(`Expense items saved successfully!`, 1);
        getExpenseItems();
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }
    setIsLoading(false);
  }, [selectedItems, companyId]);

  console.log("Expense Items:", expenseItems, selectedItems);

  {
    isLoading && (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    )
  }
  return (
    <>
      {
        isLoading ? <LoaderContainer>
          <Loader />
        </LoaderContainer> :
          <Wrapper>
            <MainHeading>
              <Title>Expense Accounts</Title>
              {/* <Button onClick={handleSave}>Save</Button> */}
              <InfoMessage onClick={()=> navigate('/dashboard/manage-global-report/company-specific-items', { state: { from: 'expense_accounts' } })}>
                <HiOutlineExternalLink style={{ color: "#001BB7", width: "1.5rem", height: "1.5rem" }} />
                <MessageLink> Navigate to 
                  <span style={{ color: "#001BB7", fontWeight: 500, padding: "0 0.5rem", borderBottom: "1px dashed #001BB7" }}>Company Level Pay Items</span> 
                  to add or remove expense accounts</MessageLink>
              </InfoMessage>
            </MainHeading>

            <Card>
              <ListHeader>
                <div>Reimbursement Custom Items</div>
                <div>Expense Accounts</div>
              </ListHeader>

              {expenseItems?.length > 0 ? (
                <ListWrapper>
                  {expenseItems?.map((item) => (
                    <ItemRow key={item.custom_input_id}>
                      <Label>{item.name}</Label>
                      <CheckboxWrapper>
                        <Checkbox
                          checked={selectedItems.includes(item.custom_input_id)}
                          onChange={() => handleCheckboxChange(item.custom_input_id)}
                          disabled
                        />
                        <Checkmark />
                      </CheckboxWrapper>
                    </ItemRow>
                  ))}
                </ListWrapper>
              ) :
                null
              }

              {/* if the list is empty*/}
              {expenseItems?.length === 0 && (
                <Wrapper>
                  <Card>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "3rem",
                        textAlign: "center",
                        color: "#6b7280",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "3rem",
                          marginBottom: "1rem",
                          opacity: 0.3,
                        }}
                      >
                        📋
                      </div>
                      <h3
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "600",
                          margin: "0 0 0.5rem 0",
                          color: "#374151",
                        }}
                      >
                        No Expense Items Found
                      </h3>
                      <p
                        style={{
                          fontSize: "0.875rem",
                          margin: 0,
                          opacity: 0.7,
                        }}
                      >
                        There are currently no expense accounts available to display.
                      </p>
                    </div>
                  </Card>
                </Wrapper>
              )}
            </Card>
          </Wrapper>
      }
    </>
  );
};

export default ExpenseAccounts;
